import api from "../security/api";

const viewRoles = (client, instance) => {    
    return api
        .get(`roles/findAll?client=${client}&instance=${instance}`)
};

const rolesService = {
    viewRoles,
};


export default rolesService;
